import { Button, Modal, NumberInput, rem, TextInput } from "@mantine/core";
import React, { useState } from "react";
import { notifications } from "@mantine/notifications";
import { IconCheck, IconX } from "@tabler/icons-react";
import { AdvancedSettings, PlayerColor, Position } from "../models";
import { useSettingsStorage } from "../ZustandState";
import AdvancedSettingsComponent from "./AdvancedSettings";

interface Props {
    opened: boolean;
    close: () => void;
    name: string;
    onAddPosition: (name: string, advancedSettings: AdvancedSettings) => void;
    playerColor: PlayerColor;
    positions: Position[];
}

const AddPositionModal: React.FC<Props> = ({ opened, close, name, onAddPosition, playerColor, positions }) => {
    const [selectedName, setSelectedName] = useState(name);
    const settings = useSettingsStorage();
    const [startRating, setStartRating] = useState(settings.startRating);
    const [advancedSettings, setAdvancedSettings] = useState<AdvancedSettings>({
        engineSource: "lichess",
        timeControls: ["ultraBullet", "bullet", "blitz", "rapid", "classical"],
        sinceYear: "2010",
        sinceMonth: "January",
    });

    const handleOnSetStartRating = (value: number) => {
        setStartRating(value);
        settings.setSettings({ ...settings, startRating: value });
    };
    return (
        <Modal
            opened={opened}
            onClose={close}
            title={`Add ${playerColor === "w" ? "white" : "black"} opening`}
            centered
            padding={20}
        >
            <div className="">
                <TextInput
                    className="mb-4"
                    label="Name"
                    value={selectedName}
                    onChange={(e) => setSelectedName(e.target.value)}
                />
                <NumberInput
                    value={startRating}
                    hideControls
                    label="Start rating"
                    onChange={(value) => handleOnSetStartRating(parseInt(value as string))}
                />

                <AdvancedSettingsComponent
                    advancedSettings={advancedSettings}
                    setAdvancedSettings={setAdvancedSettings}
                />

                <Button
                    className="mt-6"
                    color="green"
                    h="3rem"
                    onClick={() => {
                        if (positions.find((p) => p.name === selectedName && p.defaultPlayerColor === playerColor)) {
                            notifications.show({
                                title: "Position with that name already exists",
                                message: "",
                                icon: <IconX style={{ width: rem(18), height: rem(18) }} />,
                                color: "red",
                            });
                            return;
                        }
                        onAddPosition(selectedName, advancedSettings);
                        notifications.show({
                            title: "Position added",
                            message: "",
                            icon: <IconCheck style={{ width: rem(18), height: rem(18) }} />,
                            color: "green",
                        });
                        close();
                    }}
                    fullWidth
                >
                    <span className="text-lg">Add</span>
                </Button>
            </div>
        </Modal>
    );
};

export default AddPositionModal;
